import axios from '../../axios/index.js'

export default {
    getList(data) {
        return axios.get('discrepancies/list', { params: data })
    },
    
    getDiscrepanciesByClient(data) {
        return axios.get('discrepancies/client', { params: data })
    },
    
    getDiscrepanciesByVendor(data) {
        return axios.get('discrepancies/vendor', { params: data })
    },

    getDiscrepanciesByType(data) {
        return axios.get('discrepancies/type', { params: data })
    },

}